import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EstadoVagaEnum,
  ExperienciaProfissional,
  HabilitacaoAcademica,
  Vaga,
} from '@app/features-modules/bolsa-de-profissionais/api';
import { forkJoin, map } from 'rxjs';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { Pagination } from '@app/shared/model';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { TagModule } from 'primeng/tag';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models';
import { DrawerModule } from 'primeng/drawer';
import { MaisDetalheVagaComponent } from '../mais-detalhe-vaga/mais-detalhe-vaga.component';
import { AvatarGroup } from 'primeng/avatargroup';
import { Avatar } from 'primeng/avatar';
import { ApiService } from '@core/providers/http';
import {
  CandidaturaService,
  HabilitacaoAcademicaService,
  ExperienciaProfissionalService,
  VagaService,
  ProfissionaisEnumService,
  ProfissionalService,
} from '@app/features-modules/bolsa-de-profissionais/services';
import { CardCandidaturaComponent } from './card-candidatura/card-candidatura.component';
import { CardProfissionalComponent } from './card-profissional/card-profissional.component';
import { BadgeModule } from 'primeng/badge';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { CandidaturaDetalheComponent } from '../../candidaturas/candidatura-detalhe/candidatura-detalhe.component';
import { EmpresaSectorService } from '@app/features-modules/bolsa-de-profissionais/services';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-detalhe-vaga',
  standalone: true,
  imports: [
    CommonModule,
    Button,
    TabsModule,
    ConfirmDialog,
    ReactiveFormsModule,
    DialogModule,
    SelectModule,
    InputText,
    TagModule,
    BackButtonComponent,
    PaginatorControlComponent,
    ToastModule,
    SearchBarComponent,
    DrawerModule,
    MaisDetalheVagaComponent,
    Avatar,
    AvatarGroup,
    CardProfissionalComponent,
    CardCandidaturaComponent,
    BadgeModule,
    OverlayBadgeModule,
    DataVoidComponent,
    CandidaturaDetalheComponent,
  ],
  providers: [
    ConfirmationService,
    MessageService,
    ApiService,
    CandidaturaService,
    HabilitacaoAcademicaService,
    ExperienciaProfissionalService,
    VagaService,
    ApiService,
    ProfissionaisEnumService,
    ProfissionalService,
    EmpresaSectorService,
  ],
  templateUrl: './detalhe-vaga.component.html',
  styleUrl: './detalhe-vaga.component.scss',
})
export class DetalheVagaComponent implements OnInit {
  route = inject(ActivatedRoute);
  vagaDetailID = -1;

  @Output() onCloseModal = new EventEmitter<boolean>();

  candidatura = input<any>();
  router = inject(Router);
  //route: ActivatedRoute = inject(ActivatedRoute);

  candidaturaRequest: any;
  experienciaService = inject(ExperienciaProfissionalService);
  profissionalService = inject(ProfissionalService);
  profissionalEnumService = inject(ProfissionaisEnumService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  candidaturaService = inject(CandidaturaService);
  vagaService = inject(VagaService);
  habilitacaoService = inject(HabilitacaoAcademicaService);
  empresaSectorService = inject(EmpresaSectorService);
  listaHabilitacoes: HabilitacaoAcademica[] = [];
  //items: MenuItem[];
  listaExperiencias: ExperienciaProfissional[] = [];
  empresaLogoUrl: string | null = null;
  empresaLogoError = false;
  vagaDetail: any;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
  isLoading: boolean = false;
  isLoadingProof: boolean = false;
  candidatosCount: any;
  candidatosList: any;
  form!: FormGroup;
  activeTab: number = 0;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;
  pagination: Pagination<any> = new Pagination<any>();

  listaVagas: any[] = [];
  maisDetalheVagas: Vaga | undefined | null;
  showDetalhe: boolean = false;

  estadoOption = [
    { id: EstadoVagaEnum.NUMBER_1, designacao: 'Aberto' },
    { id: EstadoVagaEnum.NUMBER_2, designacao: 'Fechado' },
  ];

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'nomeProfissional',
      placeholder: 'Nome do profissional',
    },
    {
      type: 'dropdown',
      controlName: 'nivelHabilitação',
      placeholder: 'Formação',
      options: this.listaHabilitacoes,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'ProfissionalID',
      placeholder: 'Experiência de função',
      options: this.listaExperiencias,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  estadoVagaMap: Record<number, { label: string; severity: any }> = {
    1: { label: 'Aberto', severity: 'success' },
    2: { label: 'Fechado', severity: 'warn' },
    3: { label: 'Cancelado', severity: 'danger' },
  };
  empresaID: number | null = null;
  constructor(private fb: FormBuilder) {
    // this.vagaDetailID = Number(this.route.snapshot.params['id']);
    //this.vagaService.getVagaByIdIdGet(this.vagaDetailID);
  }

  ngOnInit(): void {
    const empresaIDParam = this.route.snapshot.queryParamMap.get('empresaID');
    this.empresaID = empresaIDParam ? Number(empresaIDParam) : null;
    if (this.id) {
      this.getFilters();

      this.loadVagaDetails(this.id);
    }
    this.getExperiencias();
    this.getHabilitacoes();

    this.form = this.fb.group({
      nomeProfissional: [null],
      nivelHabilitação: [null],
      ProfissionalID: [null],
    });
  }

  getFilters() {
    forkJoin({
      nivelHabilitacao: this.profissionalEnumService.getAllNivelHabilitacao(),
      estadoCandidatura: this.profissionalEnumService.getAllEstadoCandidatura(),
      profissionais: this.profissionalService.list({
        PageSize: 100,
        PageNumber: 1,
      }),
    }).subscribe((response: any) => {
      const habilitacaoList = response.nivelHabilitacao?.data
        ? Object.entries(response.nivelHabilitacao.data).map(
            ([id, designacao]) => ({
              id,
              designacao,
            })
          )
        : [];
      // Estado da candidatura: transforma objeto em array de {id, designacao}
      const estadoOption = response.estadoCandidatura?.data
        ? Object.entries(response.estadoCandidatura.data).map(
            ([id, designacao]) => ({
              id,
              designacao,
            })
          )
        : [];
      // Profissionais: monta label com nome e especialidadesFuncoes
      const listaExperiencias = response.profissionais?.data
        ? response.profissionais.data.map((prof: any) => ({
            id: prof.id,
            designacao: `${prof.nome} - ${
              prof.especialidadesFuncoes ||
              prof.nivelHabilitacao ||
              'Função Desconhecida'
            }`.trim(),
          }))
        : [];

      this.filters[1].options = habilitacaoList;
      this.filters[2].options = listaExperiencias;
    });
  }

  showFilter = false;

  showDialog() {
    this.showFilter = true;
  }

  onGerarComprovativo(event: any) {
    const vagaId = event?.item?.data?.id ?? event?.data?.id;
    if (!vagaId) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Não foi possível identificar a vaga.',
        life: 3000,
      });
      return;
    }

    this.isLoadingProof = true;
    this.profissionalService.gerarComprovativo({ VagaId: vagaId }).subscribe({
      next: (blob) => {
        this.isLoadingProof = false;

        const filename = `comprovativo-vaga-${vagaId}.pdf`;
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);

        this.messageService.add({
          severity: 'success',
          summary: 'Comprovativo',
          detail: 'Comprovativo gerado com sucesso.',
          life: 3000,
        });
      },
      error: (err) => {
        this.isLoadingProof = false;
        console.error('gerarComprovativo error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Falha ao gerar comprovativo.',
          life: 4000,
        });
      },
    });
  }

  get id() {
    return Number(this.route.snapshot.paramMap.get('id'));
  }

  loadVagaDetails(id: any) {
    this.isLoading = true;
    this.vagaService.show(id).subscribe((response) => {
      if (response?.retorno?.codigo === 200 && response.data) {
        this.vagaDetail = response.data;
        this.empresaSectorService
          .getPhotoEmpresaIdGet(this.vagaDetail.empresaID)
          .subscribe(
            (blob: Blob) => {
              if (blob) {
                this.empresaLogoUrl = URL.createObjectURL(blob);
              }
            },
            (error) => {
              console.error('Erro ao obter foto da empresa:', error);
              this.empresaLogoUrl = null;
            }
          );
        this.loadCandidaturas({ VagaID: this.id });
      }
    });
  }

  closeModal() {
    this.onCloseModal.emit(true);
  }

  getHabilitacoes() {
    const profissionalId =
      this.candidatura()?.profissional?.id ||
      this.candidatura()?.profissionalId;
    if (profissionalId !== undefined) {
      this.habilitacaoService.show(profissionalId).subscribe((result) => {
        if (result.retorno?.codigo === 200 && result.data) {
          this.listaHabilitacoes = Array.isArray(result.data)
            ? result.data
            : [result.data];
        }
      });
    }
  }

  loadCandidaturas(queryParams: any = {}) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      VagaID: this.id,
    };
    this.candidaturaService.list(params).subscribe((result) => {
      if (result.retorno?.codigo === 200 && result.data) {
        this.pagination = new Pagination<any>().deserialize(result);
        this.candidatosList = result.data;
        this.candidatosCount = result.records;
      }
    });
  }

  handleFormValueChange(event: any) {
    this.loadCandidaturas(event);
  }

  getExperiencias() {
    const profissionalId =
      this.candidatura()?.profissional?.id ||
      this.candidatura()?.profissionalId;
    if (profissionalId !== undefined) {
      this.experienciaService
        .listByProfissionalId(profissionalId)
        .subscribe((result) => {
          if (result.retorno?.codigo === 200 && result.data) {
            this.listaExperiencias = result.data;
            this.filters[2].options = this.listaExperiencias.map(
              (experiencia) => ({
                id: experiencia.id,
                designacao: `${experiencia.nomeEmpresa} - ${experiencia.designacaoFuncao}`,
              })
            );
          }
        });
    }
  }

  actionClick(vaga: Vaga) {
    this.maisDetalheVagas = vaga;
    this.showDetalhe = true;
  }

  deleteVaga(id?: any): void {
    if (!id) return;

    this.confirmationService.confirm({
      header: 'Cancelar Candidatura?',
      message: `A vaga será cancelada. Deseja continuar?`,
      rejectButtonProps: {
        label: 'Cancelar',
        icon: 'pi pi-times',
        outlined: true,
        size: 'small',
      },
      acceptButtonProps: {
        label: 'Sim',
        icon: 'pi pi-check',
        size: 'small',
      },
      accept: () => {
        this.isLoading = true;
        this.vagaService.delete(id).subscribe(
          () => {
            this.listaVagas = this.listaVagas.filter((vaga) => vaga.id !== id);
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Vaga excluída com sucesso!',
              life: 3000,
            });
            this.isLoading = false;
            // Wait 2 seconds before redirecting
            setTimeout(() => {
              this.router.navigate(['/bolsa-profissionais/vagas']);
            }, 2000);
          },
          (error) => {
            console.error('Erro ao excluir vaga:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao excluir a vaga.',
              life: 3000,
            });
            this.isLoading = false;
          }
        );
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelada',
          detail: 'Exclusão cancelada',
          life: 3000,
        });
      },
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadCandidaturas({ VagaID: this.id });
  }

  getSeverity(estado: string): any {
    switch (estado) {
      case 'Senior':
        return 'info';
      case 'Junior':
        return 'success';
      default:
        return 'info';
    }
  }

  trackByUserId(index: number, item: any) {
    return item?.id ?? index;
  }

  onTabClick(tabIndexOrEvent: number | Event) {
    // se veio um Event, a gente usa o índice atual
    const idx =
      typeof tabIndexOrEvent === 'number' ? tabIndexOrEvent : this.activeTab;
    console.log('Tab clicked:', idx);
    switch (idx) {
      case 0:
        this.loadCandidaturas();
        break;
      case 1:
        this.loadCandidaturas();
        break;
    }
  }
}
